import React from 'react'
import { Container } from './SectionTitle.styles'
import { SectionTitleProps } from './SectionTitle.types'

export const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  subtitle,
  level = 2,
  size = 'medium',
  className,
  style,
  titleContent,
  subtitleContent,
  id,
  children,
}) => {
  const HeadingTag = `h${level}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

  return (
    <Container className={className} style={style} $size={size}>
      <HeadingTag className="title" id={id}>
        {children || titleContent || title}
      </HeadingTag>
      {(subtitle || subtitleContent) && (
        <div className="subtitle">{subtitleContent || subtitle}</div>
      )}
    </Container>
  )
}
